import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  FlexboxGrid,
  IconButton,
  Message,
  Modal,
  Panel,
  Stack,
  toaster,
  Tooltip,
  Uploader,
  Whisper
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import VisibleIcon from '@rsuite/icons/Visible';
import Resizer from 'react-image-file-resizer';
import pdf_one from './pptout/pdf_one.jpg';
import pdf_two from './pptout/pdf_two.jpg';
import excel_one from './pptout/excel_one.jpg';
import excel_two from './pptout/excel_two.jpg';
import ppt_one from './pptout/ppt_one.jpg';
import ppt_two from './pptout/ppt_two.jpg';
import ppt_three from './pptout/ppt_three.jpg';
import ppt_four from './pptout/ppt_four.jpg';
import ppt_six from './pptout/ppt_six.png';
import ppt_seven from './pptout/ppt_seven.jpg';
import ppt_eight from './pptout/ppt_eight.jpg';
import ppt_nine from './pptout/ppt_nine.jpg';
import ppt_ten from './pptout/ppt_six.png';
import ppt_eleven from './pptout/m3.jpg';
import ppt_forrteen from './pptout/14.jpg';
import ppt_fifteen from './pptout/15.jpg';
import ppt_sixteen from './pptout/16.jpg';
import ppt_seventeen from './pptout/17.jpg';
import f12 from './templates/s12.jpg';
import f13 from './templates/s13.jpg';
import globalIP from '@/GlobelIP';


import view1 from './tempview/Capture1.jpg';
import view2 from './tempview/Capture2.jpg';
import view3 from './tempview/Capture3.jpg';
import view4 from './tempview/Capture4.jpg';
import view5 from './tempview/Capture5.jpg';
import view6 from './tempview/Capture6.jpg';
import view7 from './tempview/Capture7.jpg';
import view8 from './tempview/Capture8.jpg';
import view9 from './tempview/Capture9.jpg';
import view10 from './tempview/Capture10.jpg';
import view11 from './tempview/Capture11.jpg';
import view12 from './tempview/Capture12.jpg';
import view13 from './tempview/Capture13.jpg';
import view14 from './tempview/Capture14.jpg';
import view15 from './tempview/Capture15.jpg';
import view16 from './tempview/Capture16.jpg';
import view17 from './tempview/Capture17.jpg';
import view18 from './tempview/Capture18.jpg';

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const CataFormat1 = ({ activeKeyside, buyertype, buyerName }) => {
  ///// PPT Format Start /////
  const [mainid, setMainid] = useState();
  const [buyer, setBuyer] = useState('');
  const [fileInfo1, setFileInfo1] = useState({
    CSPath: null,
    LSPath: null,
    HPath: null
  });
  const [selectedSlides, setSelectedSlides] = useState([]);
  const [cdata, setCdata] = useState({
    CoverSlide: 'No',
    LastSlide: 'No',
    Type: '',
    Header: 'No',
    BuyerName: '',
    Slides: []
  });

  useEffect(() => {
    setCdata(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit = async e => {
    e.preventDefault();
    if (cdata.Type == 'Buyer') {
      if (cdata.BuyerName == '' || cdata.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata.CSPath) {
          formData.append('files.CSPath', cdata.CSPath);
        }
        if (cdata.LSPath) {
          formData.append('files.LSPath', cdata.LSPath);
        }
        if (cdata.HPath) {
          formData.append('files.HPath', cdata.HPath);
        }
        const updatedCdata = {
          ...cdata,
          Slides: selectedSlides.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid) {
          url = `${globalIP}/api/temp-libs/${mainid}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-libs`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body Slide !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata.CSPath) {
          formData.append('files.CSPath', cdata.CSPath);
        }
        if (cdata.LSPath) {
          formData.append('files.LSPath', cdata.LSPath);
        }
        if (cdata.HPath) {
          formData.append('files.HPath', cdata.HPath);
        }
        const updatedCdata = {
          ...cdata,
          Slides: selectedSlides.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid) {
          url = `${globalIP}/api/temp-libs/${mainid}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-libs`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            // Refresh page after 2 seconds (2000 milliseconds)
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const resizeFile = blobfile =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        blobfile,
        1500,
        1500,
        'JPEG',
        90,
        0,
        uri => {
          resolve(uri); // Resolving with the resized Base64 string
        },
        'blob', // Return as base64
        900,
        900
      );
    });
  const handleImageUpload = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile);
      if (allowedExtensions.includes(fileExtension)) {
        setCdata({
          ...cdata,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo1(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [buyertype, buyerName]);
  const fetchData = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-libs?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-libs?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Slides || [];
      setFileInfo1(prev => ({
        ...prev,
        CSPath: `${globalIP}${json.data[0]?.attributes?.CSPath?.data?.attributes?.url ?? ''}`
      }));
      setFileInfo1(prev => ({
        ...prev,
        LSPath: `${globalIP}${json.data[0]?.attributes?.LSPath?.data?.attributes?.url ?? ''}`
      }));
      setFileInfo1(prev => ({
        ...prev,
        HPath: `${globalIP}${json.data[0]?.attributes?.HPath?.data?.attributes?.url ?? ''}`
      }));
      setCdata(prev => ({
        ...prev,
        CoverSlide: json.data[0]?.attributes?.CoverSlide ?? 'No',
        Header: json.data[0]?.attributes?.Header ?? 'No',
        LastSlide: json.data[0]?.attributes?.LastSlide ?? 'No',
        Slides: fetchedSlides
      }));
      // console.log('LastfetchedSlidesSlide', fetchedSlides);
      setSelectedSlides(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange = (key, checked) => {
    console.log('cdata--->', cdata);
    setCdata({
      ...cdata,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: ppt_one, view: 'view1' },
    { TempName: 'Format F2', BuyerName: '', imgSrc: ppt_two, view: 'view2' },
    { TempName: 'Format F3', BuyerName: '', imgSrc: ppt_three, view: 'view3' },
    { TempName: 'Format F4', BuyerName: '', imgSrc: ppt_four, view: 'view4' },
    { TempName: 'Format F5', BuyerName: '', imgSrc: ppt_three, view: 'view3' },
    { TempName: 'Format F6', BuyerName: '', imgSrc: ppt_six, view: 'view6' },
    { TempName: 'Format Two F1', BuyerName: '', imgSrc: ppt_seven, view: 'view7' },
    { TempName: 'Format Three F1', BuyerName: '', imgSrc: ppt_eight, view: 'view8' },
    { TempName: 'Format Four F1', BuyerName: '', imgSrc: ppt_nine, view: 'view9' },
    { TempName: 'Format F7', BuyerName: '', imgSrc: ppt_ten, view: 'view10' },
    { TempName: 'Format F8', BuyerName: '', imgSrc: ppt_two, view: 'view11' },
    { TempName: 'Format F9', BuyerName: '', imgSrc: ppt_eleven, view: 'view12' },
    { TempName: 'Format F10', BuyerName: '', imgSrc: ppt_eleven, view: 'view13' },
    { TempName: 'Format F12', BuyerName: '', imgSrc: f12, view: 'view14' },
    { TempName: 'Format F13', BuyerName: '', imgSrc: f13, view: 'view15' },
    { TempName: 'Format F14', BuyerName: '', imgSrc: ppt_seventeen, view: 'view16' },
    { TempName: 'Format F15', BuyerName: '', imgSrc: ppt_forrteen, view: 'view17' },
    { TempName: 'Format F16', BuyerName: '', imgSrc: ppt_fifteen, view: 'view18' },
    { TempName: 'Format F17', BuyerName: '', imgSrc: ppt_sixteen, view: 'view19' }
  ];
  const handleCheckboxChange1 = (slide, checked) => {
    if (checked) {
      setSelectedSlides(prev => [...prev, slide]);
    } else {
      setSelectedSlides(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// PPT Format End /////

  ///// PDF Format Start /////
  const [mainid1, setMainid1] = useState();
  const [buyer1, setBuyer1] = useState('');
  const [fileInfo11, setFileInfo11] = useState({
    CPPath: null,
    LPPath: null
  });
  const [selectedSlides1, setSelectedSlides1] = useState([]);
  const [cdata1, setCdata1] = useState({
    CoverPage: 'No',
    LastPage: 'No',
    Type: '',
    BuyerName: '',
    Pages: []
  });
  useEffect(() => {
    setCdata1(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer1(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit1 = async e => {
    e.preventDefault();
    if (cdata1.Type == 'Buyer') {
      if (cdata1.BuyerName == '' || cdata1.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata1.CPPath) {
          formData.append('files.CPPath', cdata1.CPPath);
        }
        if (cdata1.LPPath) {
          formData.append('files.LPPath', cdata1.LPPath);
        }
        const updatedCdata = {
          ...cdata1,
          Pages: selectedSlides1.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer1
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid1) {
          url = `${globalIP}/api/temp-lib-ppts/${mainid1}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-ppts`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides1.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body Pages !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata1.CPPath) {
          formData.append('files.CPPath', cdata1.CPPath);
        }
        if (cdata1.LPPath) {
          formData.append('files.LPPath', cdata1.LPPath);
        }
        const updatedCdata = {
          ...cdata1,
          Pages: selectedSlides1.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer1
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid1) {
          url = `${globalIP}/api/temp-lib-ppts/${mainid1}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-ppts`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const handleImageUpload1 = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile);

      if (allowedExtensions.includes(fileExtension)) {
        setCdata1({
          ...cdata1,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo11(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData1();
  }, [buyertype, buyerName]);
  const fetchData1 = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-ppts?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-ppts?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid1(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Pages || [];
      setFileInfo11(prev => ({
        ...prev,
        CPPath: `${globalIP}${json.data[0]?.attributes?.CPPath?.data?.attributes?.url ?? ''}`
      }));
      setFileInfo11(prev => ({
        ...prev,
        LPPath: `${globalIP}${json.data[0]?.attributes?.LPPath?.data?.attributes?.url ?? ''}`
      }));
      setCdata1(prev => ({
        ...prev,
        CoverPage: json.data[0]?.attributes?.CoverPage ?? 'No',
        LastPage: json.data[0]?.attributes?.LastPage ?? 'No',
        Pages: fetchedSlides
      }));
      setSelectedSlides1(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange11 = (key, checked) => {
    setCdata1({
      ...cdata1,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides1 = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: pdf_one, view: 'view20' },
    { TempName: 'Format F2', BuyerName: '', imgSrc: pdf_two, view: 'view21' }
  ];
  const handleCheckboxChange111 = (slide, checked) => {
    if (checked) {
      setSelectedSlides1(prev => [...prev, slide]);
    } else {
      setSelectedSlides1(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// PDF Format End /////

  ///// Excel Format Start /////
  const [mainid2, setMainid2] = useState();
  const [buyer2, setBuyer2] = useState('');
  const [fileInfo12, setFileInfo12] = useState({
    BannerPath: null
  });
  const [selectedSlides2, setSelectedSlides2] = useState([]);
  const [cdata2, setCdata2] = useState({
    Banner: 'No',
    Type: '',
    BuyerName: '',
    Body: []
  });
  useEffect(() => {
    setCdata2(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer2(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit2 = async e => {
    e.preventDefault();
    if (cdata2.Type == 'Buyer') {
      if (cdata2.BuyerName == '' || cdata2.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }
        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-excels`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides2.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }

        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-excels`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const handleImageUpload2 = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile);

      if (allowedExtensions.includes(fileExtension)) {
        setCdata2({
          ...cdata2,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo12(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData2();
  }, [buyertype, buyerName]);
  const fetchData2 = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-excels?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-excels?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid2(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Body || [];
      setFileInfo12(prev => ({
        ...prev,
        BannerPath: `${globalIP}${json.data[0]?.attributes?.BannerPath?.data?.attributes?.url ?? ''
          }`
      }));
      setCdata2(prev => ({
        ...prev,
        Banner: json.data[0]?.attributes?.Banner ?? 'No',
        Body: fetchedSlides
      }));
      setSelectedSlides2(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange12 = (key, checked) => {
    setCdata2({
      ...cdata2,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides2 = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: excel_one, view: 'view22' },
    { TempName: 'Format F2', BuyerName: '', imgSrc: excel_two, view: 'view23' }
  ];
  const handleCheckboxChange112 = (slide, checked) => {
    if (checked) {
      setSelectedSlides2(prev => [...prev, slide]);
    } else {
      setSelectedSlides2(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// Excel Format End /////
  const [img, setImg] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = val => {
    if (val == 'CSPath') {
      setImg(fileInfo1.CSPath);
    } else if (val == 'LSPath') {
      setImg(fileInfo1.LSPath);
    } else if (val == 'CPPath') {
      setImg(fileInfo1.CPPath);
    } else if (val == 'HPath') {
      setImg(fileInfo1.HPath);
    } else if (val == 'LPPath') {
      setImg(fileInfo11.LPPath);
    } else if (val == 'Banner') {
      setImg(fileInfo12.BannerPath);
    } else if (val == 'view1') {
      setImg(view2);
    } else if (val == 'view2') {
      setImg(view1);
    } else if (val == 'view3') {
      setImg(view3);
    } else if (val == 'view4') {
      setImg(view18);
    } else if (val == 'view6') {
      setImg(view4);
    } else if (val == 'view8') {
      setImg(view6);
    } else if (val == 'view9') {
      setImg(view9);
    } else if (val == 'view10') {
      setImg(view4);
    } else if (val == 'view12') {
      setImg(view5);
    } else if (val == 'view13') {
      setImg(view5);
    } else if (val == 'view14') {
      setImg(view7);
    } else if (val == 'view15') {
      setImg(view8);
    } else if (val == 'view16') {
      setImg(view11);
    } else if (val == 'view17') {
      setImg(view10);
    } else if (val == 'view18') {
      setImg(view12);
    } else if (val == 'view19') {
      setImg(view13);
    } else if (val == 'view20') {
      setImg(view14);
    } else if (val == 'view21') {
      setImg(view16);
    } else if (val == 'view22') {
      setImg(view15);
    } else if (val == 'view23') {
      setImg(view17);
    }

    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Panel bordered>
        {activeKeyside === 'content1' && (
          <>
            <Stack justifyContent="flex-end">
              <Button appearance="primary" color="cyan" onClick={submit}>
                Save
              </Button>
            </Stack>
            <Stack>
              <b style={{ marginBottom: '5px' }}>Cover Slide</b>
              <Checkbox
                checked={cdata.CoverSlide === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange('CoverSlide', checked)}
              />
            </Stack>
            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Dimension 1200 x 800 px</p>
                <Uploader
                  onChange={e => handleImageUpload(e, 'CSPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 150, height: 150 }}>
                    {fileInfo1.CSPath ? (
                      <img src={fileInfo1.CSPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    // onClick={handleOpen}
                    onClick={() => handleOpen('CSPath')}
                  />
                </Whisper>
              </Stack>
            </Panel>
            <Stack>
              <b style={{ marginBottom: '5px' }}>Header</b>
              <Checkbox
                checked={cdata.Header === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange('Header', checked)}
              />
            </Stack>
            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Approx. dimension 1000 x 120 px</p>
                <Uploader
                  onChange={e => handleImageUpload(e, 'HPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 1000, height: 120 }}>
                    {fileInfo1.HPath ? (
                      <img src={fileInfo1.HPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    // onClick={handleOpen}
                    onClick={() => handleOpen('HPath')}
                  />
                </Whisper>
              </Stack>
            </Panel>

            <Stack>
              <b>Body Slides</b>
              <p style={{ color: 'red' }}>*</p>
            </Stack>
            <Divider style={{ marginTop: '5px' }} />

            <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
              {slides.map(slide => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                  <Panel bordered>
                    <Stack direction="column">
                      <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                      <Stack>
                        <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                          <IconButton
                            icon={<VisibleIcon />}
                            size="sm"
                            active
                            onClick={() => handleOpen(slide.view)}
                          />
                        </Whisper>
                        <Checkbox
                          checked={selectedSlides.some(s => s.TempName === slide.TempName)}
                          onChange={(value, checked) => handleCheckboxChange1(slide, checked)}
                        >
                          {slide.TempName}
                        </Checkbox>
                      </Stack>
                    </Stack>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
            <Stack>
              <b style={{ marginBottom: '10px' }}>Last Slide</b>
              <Checkbox
                checked={cdata.LastSlide === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange('LastSlide', checked)}
              />
            </Stack>
            <Divider style={{ marginTop: '5px' }} />

            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Dimension 1200 x 800 px</p>
                <Uploader
                  onChange={e => handleImageUpload(e, 'LSPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 150, height: 150 }}>
                    {fileInfo1.LSPath ? (
                      <img src={fileInfo1.LSPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    onClick={() => handleOpen('LSPath')}
                  // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                  />
                </Whisper>
              </Stack>
            </Panel>
          </>
        )}
        {activeKeyside === 'content2' && (
          <>
            <Stack justifyContent="flex-end">
              <Button appearance="primary" color="cyan" onClick={submit1}>
                Save
              </Button>
            </Stack>
            <Stack>
              <b style={{ marginBottom: '5px' }}>Cover Page</b>
              <Checkbox
                checked={cdata1.CoverPage === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange11('CoverPage', checked)}
              />
            </Stack>
            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Dimension 1414 x 2000 px</p>
                <Uploader
                  onChange={e => handleImageUpload1(e, 'CPPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 150, height: 150 }}>
                    {fileInfo11.CPPath ? (
                      <img src={fileInfo11.CPPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    onClick={() => handleOpen('CPPath')}
                  // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                  />
                </Whisper>
              </Stack>
            </Panel>
            <Stack>
              <b>Body Pages</b>
              <p style={{ color: 'red' }}>*</p>
            </Stack>
            <Divider style={{ marginTop: '5px' }} />

            <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
              {slides1.map(slide => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                  <Panel bordered>
                    <Stack direction="column">
                      <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                      <Stack>
                        <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                          <IconButton
                            icon={<VisibleIcon />}
                            size="sm"
                            active
                            onClick={() => handleOpen(slide.view)}
                          />
                        </Whisper>
                        <Checkbox
                          checked={selectedSlides1.some(s => s.TempName === slide.TempName)}
                          onChange={(value, checked) => handleCheckboxChange111(slide, checked)}
                        >
                          {slide.TempName}
                        </Checkbox>
                      </Stack>
                    </Stack>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
            <Stack>
              <b style={{ marginBottom: '10px' }}>Last Slide</b>
              <Checkbox
                checked={cdata1.LastPage === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange11('LastPage', checked)}
              />
            </Stack>
            <Divider style={{ marginTop: '5px' }} />

            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Dimension 1414 x 2000 px</p>
                <Uploader
                  onChange={e => handleImageUpload1(e, 'LPPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 150, height: 150 }}>
                    {fileInfo11.LPPath ? (
                      <img src={fileInfo11.LPPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    onClick={() => handleOpen('LPPath')}
                  // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                  />
                </Whisper>
              </Stack>
            </Panel>
          </>
        )}

        {activeKeyside === 'content3' && (
          <>
            <Stack justifyContent="flex-end">
              <Button appearance="primary" color="cyan" onClick={submit2}>
                Save
              </Button>
            </Stack>
            <Stack>
              <b style={{ marginBottom: '5px' }}>Banner2</b>
              <Checkbox
                checked={cdata2.Banner === 'Yes'}
                onChange={(value, checked) => handleCheckboxChange12('Banner', checked)}
              />
            </Stack>
            <Panel bordered>
              <Stack direction="column">
                <p style={{ color: 'red' }}>Approx. dimension 1000 x 120 px</p>
                <Uploader
                  onChange={e => handleImageUpload2(e, 'BannerPath')}
                  fileListVisible={false}
                  accept="image/jpeg,image/jpg"
                  listType="picture"
                  action={''}
                >
                  <button style={{ width: 1000, height: 120 }}>
                    {fileInfo12.BannerPath ? (
                      <img src={fileInfo12.BannerPath} width="100%" height="100%" />
                    ) : (
                      <CameraRetroIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>

                <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                  <IconButton
                    icon={<VisibleIcon />}
                    size="sm"
                    active
                    onClick={() => handleOpen('Banner')}
                  // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                  />
                </Whisper>
              </Stack>
            </Panel>
            <Stack>
              <b>Body</b>
              <p style={{ color: 'red' }}>*</p>
            </Stack>

            <Divider style={{ marginTop: '5px' }} />

            <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
              {slides2.map(slide => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                  <Panel bordered>
                    <Stack direction="column">
                      <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                      <Stack>
                        <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                          <IconButton
                            icon={<VisibleIcon />}
                            size="sm"
                            active
                            onClick={() => handleOpen(slide.view)}
                          />
                        </Whisper>
                        <Checkbox
                          checked={selectedSlides2.some(s => s.TempName === slide.TempName)}
                          onChange={(value, checked) => handleCheckboxChange112(slide, checked)}
                        >
                          {slide.TempName}
                        </Checkbox>
                      </Stack>
                    </Stack>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
          </>
        )}
      </Panel>
      <Modal open={open} onClose={handleClose} size="lg">
        <Modal.Header>
          <Modal.Title>
            <b>Preview</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          <img src={img} style={{ width: '800px', height: '500px' }} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="primary" color="cyan">
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default CataFormat1;
